"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Адрасы",
        "advertising": "Рэклама",
        "afisha": "Афіша",
        "all": "Усе сервісы",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Праграмы",
        "audience": "Аудитории",
        "auto": "Аўто",
        "autoru": "auto.ru",
        "avia": "Авіяквiткі",
        "aziada": "Азіяда",
        "ba": "Баян",
        "backapv": "Партнёр Я.Мапаў",
        "balance": "Баланс",
        "bar": "Бар",
        "bar-ie": "Бар для IЕ",
        "bar-ie9": "Бар для ІЕ9",
        "bayan": "Банеры Яндекса",
        "blogs": "Блогi",
        "books": "Кнігі",
        "browser": "Браўзер",
        "calendar": "Каляндар",
        "captcha": "ой...",
        "catalogwdgt": "Каталог віджэтаў",
        "chrome": "Хром з пошукам Яндекса",
        "city": "Гарады",
        "cityday": "Дзень горада",
        "clickhouse": "ClickHouse",
        "collection": "Калекцыя",
        "company": "Кампанія",
        "contest": "Contest",
        "delivery": "Доставка",
        "desktop": "Персанальны пошук",
        "direct": "Дырэкт",
        "direct.market": "Маркет",
        "disk": "Дыск",
        "display": "Дысплэй",
        "ege": "АДЭ",
        "expert": "Эксперт",
        "feedback": "Зваротная сувязь",
        "feedback2": "Зваротная сувязь",
        "ff": "ФФ з пошукам Яндекса",
        "fotki": "Фоткі",
        "fresh": "Свежае",
        "games": "Гульні",
        "geocontext": "Геакантэкст",
        "goroda": "Гарады",
        "help": "Дапамога",
        "i": "Мае сервісы",
        "ie": "ІЕ з пошукам Яндекса",
        "images": "Выявы",
        "images-com": "Выявы",
        "interests": "Інтарэсы",
        "internet": "Інтэрнэт",
        "kassa": "Каса",
        "keyboard": "Клавіятура",
        "kraski": "Фарбы",
        "kuda": "Куды ўсе ідуць",
        "large": "Яндекс для слабых на зрок",
        "legal": "Прававыя дакументы",
        "lenta": "Стужка",
        "libra": "Бібліятэка",
        "literacy": "Тыдзень барацьбы за пісьменнасць",
        "local": "Лакальная сетка",
        "lost": "Незабудкі",
        "love": "Дзень узаемнага прыцягнення — 13 жніўня",
        "mail": "Пошта",
        "maps": "Мапы",
        "maps-wiki": "Народная мапа",
        "market": "Маркет",
        "market.advertising": "Маркет",
        "master": "Майстар",
        "metrika": "Метрыка",
        "metro": "Метро",
        "mobile": "Мабільны",
        "moikrug": "Мой Круг",
        "money": "Грошы",
        "museums": "Дні гістарычнай і культурнай спадчыны",
        "music": "Музыка",
        "music-partner": "Музыка: статыстыка",
        "nahodki": "Мае знаходкі",
        "nano": "Нана",
        "newhire": "Нанiматар",
        "news": "Навіны",
        "notifications": "Натыфікацыйная панэль",
        "oauth": "Аўтарызацыя",
        "online": "Анлайн",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Цытаты",
        "partners": "Рэкламная сетка",
        "partnersearch": "Пошук для партнёраў",
        "passport": "Пашпарт",
        "pdd": "Пошта для дамена",
        "peoplesearch": "Людзі",
        "perevod": "Перакладчык",
        "probki": "Пробкі",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Адказы",
        "rabota": "Праца",
        "radar": "Радар",
        "ramazan": "",
        "rasp": "Расклады",
        "realty": "Нерухомасць",
        "referats": "Рэфераты",
        "rk": "Ёсць пытанні?",
        "root": "Яндекс.Алімпіяда для Unix адміністратараў",
        "school": "Школа",
        "search": "Пошук",
        "server": "Сервер",
        "shtrafi": "Штрафы",
        "site": "Пошук для сайта",
        "slovari": "Слоўнікі",
        "so": "Самаабарона",
        "social": "Сацыялізм",
        "soft": "Праграмы",
        "sport": "Спорт",
        "sprav": "Даведнік",
        "start": "Стартавая старонка",
        "stat": "Статыстыка",
        "subs": "Падпіскі",
        "taxi": "Таксі",
        "telephony": "Телефония",
        "terms": "Размоўнік",
        "tests": "Тэсты і апытанні",
        "tickets": "Квіткі",
        "time": "Яндекс.Час",
        "toloka": "Яндекс.Талака",
        "toster": "Тосты",
        "translate": "Перакладчык",
        "tune": "Наладкі",
        "tv": "ТБ",
        "uslugi": "Паслугі",
        "video": "Відэа",
        "video-com": "Відэа",
        "vno": "ЗНА",
        "wdgt": "Віджэты",
        "weather": "Надвор'е",
        "webmaster": "Вэбмайстар",
        "webmaster-api": "API Вэбмайстра",
        "widgets": "Віджэты",
        "wordstat": "Статыстыка",
        "wow": "Я.ру",
        "www": "Пошук",
        "xmlsearch": "XML",
        "yaca": "Каталог",
        "yamb": "Медыйныя банеры",
        "zakladki": "Закладкі"
    }
};